import ArrowBack from '@mui/icons-material/ArrowBack';
import { Autocomplete, Button, Card, CardContent, CardHeader, Chip, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { editUserHobbies, getAllHobbies, saveOrUpdateHabbits } from '../../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useFormik } from 'formik';
import { hobbiesEditSchema } from '../../../ValidationSchema';

export const HobbyEdit = () => {
  const [hobbiesData, setHobbiesData] = useState([]);
  const [userHobbies, setUserHobbies] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  // const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchAllHobbies = async () => {
      try {
        const response = await getAllHobbies();
        if (response.status === 200 || response.status === 201) {
          setHobbiesData(response.data.data || []);
        } else {
          toast.error(response.data.message || 'Failed to fetch all hobbies');
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch all hobbies');
      }
    };

    const fetchUserHobbies = async () => {
      try {
        const response = await editUserHobbies();
        if (response.status === 200 || response.status === 201) {
          const hobbies = response.data.data || [];
          setUserHobbies(hobbies);
        } else {
          toast.error(response.data.message || 'Failed to fetch user hobbies');
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch user hobbies');
      } finally {
        setLoading(false);
      }
    };

    fetchAllHobbies();
    fetchUserHobbies();
  }, []);

  const formik = useFormik({
    initialValues: {
      hobbies: userHobbies.flatMap(type => type.hobbies.map(hobby => hobby.id.toString())) || [],
    },
    validationSchema: hobbiesEditSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formattedData = values.hobbies.reduce((acc, hobbyId) => {
          const hobby = hobbiesData.flatMap(type => type.hobbies).find(h => h.id === parseInt(hobbyId));
          if (hobby) {
            if (!acc[hobby.type_id]) {
              acc[hobby.type_id] = [];
            }
            acc[hobby.type_id].push(hobby.id);
          }
          return acc;
        }, {});

        const payload = Object.keys(formattedData).map(typeId => ({
          tbl_Hobbies_Type_id: typeId,
          hobbies_id: formattedData[typeId].join(','),
        }));

        const response = await saveOrUpdateHabbits(payload);

        if (response.status === 200 || response.status === 201) {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate(-1);
          }, 3000); 
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to save or update hobbies');
      } finally {
        setSubmitting(false);
      }
    }
  });

  useEffect(() => {
    formik.setValues({
      hobbies: userHobbies.flatMap(type => type.hobbies.map(hobby => hobby.id.toString())) || [],
    });
  }, [userHobbies]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="col-lg-9 col-12">
      <Card className='editProfileBlock'>
        <CardHeader
          avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
          title="Hobbies"
          subheader="Update your Hobbies and Interest details"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            {hobbiesData.length > 0 ? (
              hobbiesData.map((type) => (
                <Autocomplete
                  key={type.type_id}
                  multiple
                  options={type.hobbies || []}
                  className="mb-3"
                  getOptionLabel={(option) => option.name || ''}
                  value={type.hobbies.filter(hobby => formik.values.hobbies.includes(hobby.id.toString())) || []}
                  onChange={(event, newValue) => {
                    const updatedHobbies = [
                      ...formik.values.hobbies.filter(id => !type.hobbies.some(h => h.id.toString() === id)),
                      ...newValue.map(item => item.id.toString())
                    ];
                    formik.setFieldValue('hobbies', updatedHobbies);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={(type.type_name || 'Unknown').replace(/_/g, ' ')}
                      variant="outlined"
                      error={formik.touched.hobbies && Boolean(formik.errors.hobbies)}
                      helperText={formik.touched.hobbies && formik.errors.hobbies}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.name || 'Unknown'}
                        onDelete={() => formik.setFieldValue('hobbies', formik.values.hobbies.filter(id => id !== option.id.toString()))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              ))
            ) : (
              <div>No hobbies data available</div>
            )}
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
              <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
              </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>
      <ToastContainer />
    </div>
  );
};
